((function show(global, factory) {
  'use strict';

  if (typeof define !== 'undefined' && typeof define === 'function' && define.amd) {
    // If supports for AMD is available return the value to the AMD Loader
    // and to the global (window) object in case any JS module is expecting
    // the CalculatorModule to exists on the window object.
    require([], () => {
      factory(global);
    });
  } else if (typeof exports !== 'undefined' && typeof exports === 'object') {
  // If supports for Common JS is available export the module
  // and pass is value to the global (window) object in case non Common JS code
  // is expected to work with this CalculatorModule.
    global.Calculator = factory(global);
    module.exports = global.Calculator;
  } else {
  // If not support for AMD or Common JS is available register the module in the global scope.
    global.Calculator = factory(global);
  }
})(typeof window !== 'undefined' ? window : {}, (root) => {
  'use strict';

  const dataFormParameters = root.document.querySelector('[data-form-parameters]');
  const calculatorIframe = root.document.querySelector('[data-component="calculator"]');
  let parameters = '';

  if (!calculatorIframe) {
    return;
  }

  if (dataFormParameters && dataFormParameters.innerHTML) {
    parameters = JSON.parse(dataFormParameters.innerHTML);
  }

  const showIframe = function showWidget() {
    calculatorIframe.src = parameters.widgetLink;
  };

  function register(event) {
    if (root.document.readyState === 'complete' || (event && event.target.readyState === 'complete')) {
      showIframe();
    } else {
      root.document.addEventListener('readystatechange', register);
    }
  }

  register();
})
);

define("ShowCalculator", function(){});

